import { Link, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Logo } from "@/components/Logo";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-8 bg-background p-6">
      <Logo fundo="claro" />
      <div className="flex max-w-sm flex-col items-center gap-2 text-center">
        <span className="text-[44px] font-semibold leading-none tracking-heroi tabular-nums">404</span>
        <h1 className="text-lg font-semibold">Página não encontrada</h1>
        <p className="text-sm text-muted-foreground">
          O endereço <span className="font-mono text-xs">{location.pathname}</span> não existe ou foi movido.
        </p>
      </div>
      <Button asChild variant="outline">
        <Link to="/">
          <ArrowLeft />
          Voltar para o início
        </Link>
      </Button>
    </div>
  );
};

export default NotFound;
